import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DeleteCountryAccessesMutation } from "../graphql/mutations";
import type {
  DeleteCountryAccessesMutationType,
  DeleteCountryAccessesMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useDeleteCountryAccessesMutation = (
  options?: MutationHookOptions<
    DeleteCountryAccessesMutationType,
    DeleteCountryAccessesMutationVariablesType
  >
) => {
  return useMutation<
    DeleteCountryAccessesMutationType,
    DeleteCountryAccessesMutationVariablesType
  >(DeleteCountryAccessesMutation, options);
};
